import _slicedToArray from "/codebuild/output/src931385178/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import e from "@bundled-es-modules/pdfjs-dist/build/pdf";
import t, { useRef as r, useEffect as o, useState as a, useMemo as c } from "react";

var n = function n(_ref) {
  var e = _ref.file,
      a = _ref.onDocumentComplete,
      c = _ref.page,
      n = _ref.scale,
      s = _ref.rotate,
      i = _ref.cMapUrl,
      d = _ref.cMapPacked,
      p = _ref.workerSrc,
      h = _ref.withCredentials;

  var u = r(null),
      _l = l({
    canvasEl: u,
    file: e,
    page: c,
    scale: n,
    rotate: s,
    cMapUrl: i,
    cMapPacked: d,
    workerSrc: p,
    withCredentials: h
  }),
      _l2 = _slicedToArray(_l, 2),
      w = _l2[1];

  return o(function () {
    a(w);
  }, [w]), t.createElement("canvas", {
    ref: u
  });
};

n.defaultProps = {
  onDocumentComplete: function onDocumentComplete() {}
};

var l = function l(_ref2) {
  var t = _ref2.canvasEl,
      r = _ref2.file,
      _ref2$scale = _ref2.scale,
      n = _ref2$scale === void 0 ? 1 : _ref2$scale,
      _ref2$rotate = _ref2.rotate,
      l = _ref2$rotate === void 0 ? 0 : _ref2$rotate,
      _ref2$page = _ref2.page,
      s = _ref2$page === void 0 ? 1 : _ref2$page,
      i = _ref2.cMapUrl,
      d = _ref2.cMapPacked,
      _ref2$workerSrc = _ref2.workerSrc,
      p = _ref2$workerSrc === void 0 ? "//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.1.266/pdf.worker.js" : _ref2$workerSrc,
      _ref2$withCredentials = _ref2.withCredentials,
      h = _ref2$withCredentials === void 0 ? !1 : _ref2$withCredentials;

  var _a = a(),
      _a2 = _slicedToArray(_a, 2),
      u = _a2[0],
      w = _a2[1];

  o(function () {
    e.GlobalWorkerOptions.workerSrc = p;
  }, []), o(function () {
    var t = {
      url: r,
      withCredentials: h
    };
    i && (t.cMapUrl = i, t.cMapPacked = d), e.getDocument(t).promise.then(w);
  }, [r, h]), o(function () {
    u && u.getPage(s).then(function (e) {
      return f(e);
    });
  }, [u, s, n, l, t]);

  var f = function f(e) {
    var r = 0 === l ? e.rotate : e.rotate + l;
    var o = 1;
    o = window.devicePixelRatio;
    var a = n * o,
        c = e.getViewport({
      scale: a,
      rotation: r
    }),
        s = t.current;
    if (!s) return;
    var i = s.getContext("2d");
    s.style.width = "".concat(c.width / o, "px"), s.style.height = "".concat(c.height / o, "px"), s.height = c.height, s.width = c.width;
    var d = {
      canvasContext: i,
      viewport: c
    };
    e.render(d);
  },
      m = c(function () {
    return !u;
  }, [u]),
      g = c(function () {
    return u ? u._pdfInfo.numPages : null;
  }, [u]);

  return [m, g];
};

export default n;
export { l as usePdf };